









import { Vue, Component, Prop } from "vue-property-decorator";

const numberToVh = (a: number): string => {
    return `${a}vh`;
};

@Component({
    name: "DroppoLogo",
    components: {
    },
})
export default class DroppoLogo extends Vue {
  @Prop({default: 1})
  private proportion !: number;

  private readonly baseHatWidth: number = 18;

  private get hatWidth(): string {
      return numberToVh(this.baseHatWidth * this.proportion);
  }

  private get hatStyle(): string {
      return `width: ${this.hatWidth};`;
  }


}
